module.exports = __webpack_public_path__ + "img/sxq.3cd9fe62.png";